import type { FC } from "react";

import { cn } from "@/lib/utils";
import { m } from "@recobra/i18n/messages";
import { formatTaxId } from "@recobra/schemas/client";
import { Field, FieldError, FieldLabel } from "@recobra/ui/field";
import { Input } from "@recobra/ui/input";

import { getErrorMessage, useFieldContext } from "./context";

export const TaxIdField: FC<{
  variant: "cpf" | "cnpj" | "cpf-cnpj";
  id: string;
  required?: boolean;
  colSpan?: 1 | 2;
  className?: string;
}> = ({ variant, id, required, colSpan, className }) => {
  const field = useFieldContext<string | undefined>();
  const isCpf = variant === "cpf";
  const isCpfOrCnpj = variant === "cpf-cnpj";
  const errorMessage = getErrorMessage(field.state.meta.errors[0]);

  let label = m.clients_field_cnpj();
  if (isCpfOrCnpj) label = m.clients_field_cpf_cnpj();
  else if (isCpf) label = m.clients_field_cpf();

  return (
    <Field
      data-invalid={errorMessage ? "true" : undefined}
      className={cn(colSpan === 2 ? "col-span-2" : "min-w-0", className)}
    >
      <FieldLabel htmlFor={id}>
        {label}
        {required && <span className="text-destructive">*</span>}
      </FieldLabel>
      <Input
        id={id}
        value={field.state.value ? formatTaxId(field.state.value) : ""}
        onChange={(e) => {
          const next = e.target.value ? formatTaxId(e.target.value) : undefined;
          field.handleChange(next);
        }}
        onBlur={field.handleBlur}
        autoComplete="off"
        inputMode="numeric"
        maxLength={isCpf ? 14 : 18}
        aria-required={required}
        aria-invalid={Boolean(errorMessage)}
      />
      {errorMessage ? <FieldError>{errorMessage}</FieldError> : null}
    </Field>
  );
};
